import React from "react";

// Hooks
import { useAuth } from "@hooks/useAuth";

// graphql
import { ConcretingRequestMessageType } from "@store/graphql/helpers/types.graphql";

// helpers
import utils from "@helpers/utils";

import * as Styled from "./styles";

interface MessageProps {
  message: ConcretingRequestMessageType;
}

const Message: React.FC<MessageProps> = ({ message }) => {
  const { getDecodedToken } = useAuth();
  const token = getDecodedToken();

  const selfMessage = message.user?.id === token.primarysid;

  return (
    <Styled.Container>
      <Styled.Body selfMessage={selfMessage}>
        {!selfMessage && (
          <Styled.Header>
            <Styled.UserName>{message.user?.fullName}</Styled.UserName>
            <Styled.UserRole>{message.user?.role}</Styled.UserRole>
          </Styled.Header>
        )}

        <Styled.Content>{message.message}</Styled.Content>

        <Styled.Footer>
          <Styled.Date>
            {utils.formatDateIfHave(
              message.createdAt,
              "fullDateWithoutSeconds"
            )}
          </Styled.Date>
        </Styled.Footer>
      </Styled.Body>
    </Styled.Container>
  );
};

export default Message;
